const STOCK_RELATED_KINDS = new Set(['STOCK_RISE_FALL', 'STOCK_CLOSING_PRICE']);

type WatchStatusResponse = { watchMap: Record<string, boolean> };
type QuoteSnapshotResponse = { snapData: Record<string, unknown> | null };
type WatchStatusFetcher = (stockIds: string[]) => Promise<WatchStatusResponse>;
type QuoteSnapshotFetcher = (
  securityId: number,
  lang: number,
) => Promise<QuoteSnapshotResponse>;

const watchStatusRequests = new Map<string, Promise<WatchStatusResponse>>();
const quoteSnapshotRequests = new Map<string, Promise<QuoteSnapshotResponse>>();

export function shouldFetchStockRelatedInfo(
  kind: unknown,
  stockId: unknown,
): stockId is string {
  return (
    typeof kind === 'string' &&
    STOCK_RELATED_KINDS.has(kind) &&
    typeof stockId === 'string' &&
    stockId.trim().length > 0
  );
}

export function fetchWatchStatusWithCache(
  stockId: string,
  fetcher: WatchStatusFetcher,
): Promise<WatchStatusResponse> {
  const cacheKey = stockId.trim();
  if (!cacheKey) return Promise.resolve({ watchMap: {} });

  const cachedRequest = watchStatusRequests.get(cacheKey);
  if (cachedRequest) return cachedRequest;

  const request = fetcher([cacheKey]).finally(() => {
    watchStatusRequests.delete(cacheKey);
  });
  watchStatusRequests.set(cacheKey, request);
  return request;
}

export function fetchQuoteSnapshotWithCache(
  securityId: number,
  lang: number,
  fetcher: QuoteSnapshotFetcher,
): Promise<QuoteSnapshotResponse> {
  const cacheKey = `${securityId}:${lang}`;
  const cachedRequest = quoteSnapshotRequests.get(cacheKey);
  if (cachedRequest) return cachedRequest;

  const request = fetcher(securityId, lang).finally(() => {
    quoteSnapshotRequests.delete(cacheKey);
  });
  quoteSnapshotRequests.set(cacheKey, request);
  return request;
}
